import { Injectable } from '@angular/core';
import { TooltipPosition } from '@angular/material';

@Injectable()
export class AiTooltipService {

  constructor() { }

  public getAiClass(position: TooltipPosition, color?: 'primary' | 'accent' | 'warn'): string {
    return `ai-tooltip ai-tooltip__${position}${color ? ' ai-tooltip__' + color : ''}`;
  }

}
